import * as React from 'react';

import PoweredByBlendSVG from 'login-components/Common/svg/PoweredByBlendSVG';
import PoweredByBlendHorizontalSVG from 'login-components/Common/svg/PoweredByBlendHorizontalSVG';

interface BlendLogoProps {
  format: 'stacked' | 'linear' | 'responsive';
  stackedColor?: 'loginBackground' | 'grey';
}

export default class BlendLogo extends React.PureComponent<BlendLogoProps> {
  static defaultProps = {
    stackedColor: 'loginBackground',
  };

  render() {
    const { stackedColor, format } = this.props;
    return (
      <a target="_blank" title="Blend" href="https://blend.com">
        {format === 'responsive' && (
          <span>
            <div className="u-hideOnDesktop">
              <PoweredByBlendHorizontalSVG />
            </div>
            <div className="u-hideOnMobile">
              <PoweredByBlendSVG color={stackedColor!} />
            </div>
          </span>
        )}
        {format === 'stacked' && <PoweredByBlendSVG color={stackedColor!} />}
        {format === 'linear' && <PoweredByBlendHorizontalSVG />}
      </a>
    );
  }
}
